import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '@env/environment';

// check this https://medium.com/angular-in-depth/handling-angular-environments-in-continuous-delivery-eeaee96f0aae
export interface Configuration {
  ssoIssuer?: string;
  apiBaseUrl: string;
  cmsWebappBaseUrl?: string;
  production: boolean;
  environment?: string;
  deployBaseHref?: string;
  POSTHOG_KEY?: string;
  POSTHOG_HOST?: string;
  deliveryServiceBaseUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class ConfigAssetLoaderService {
  private readonly CONFIG_URL = 'assets/config/config.json';
  private configuration$: Observable<Configuration>;

  private config: Configuration;

  constructor(private http: HttpClient) {}

  // loadConfig(): Promise<any>{

  //   const promise = this.http.get<Configuration>(this.CONFIG_URL)
  //               .toPromise()
  //               .then((response : any) => {
  //                 this.config=response;
  //               });
  //   return promise;
  // }

  public loadConfigurations(): Observable<Configuration> {
    if (!this.configuration$) {
      if (!environment?.production) {
        this.configuration$ = of(environment);
      } else {
        // Add cache-busting parameter
        const cacheBuster = `?v=${Date.now()}`;
        this.configuration$ = this.http.get<Configuration>(`${this.CONFIG_URL}${cacheBuster}`).pipe(shareReplay(1));
      }
    }
    return this.configuration$;
  }

  //used in icullen navbar see mainDecorator.jsp in icullen-webapp
  public loadConfigFromGlobalWindow(): any {
    if (!this.configuration$) {
      const apiUrl = window['config']['serverApiUrl'];
      //not needed in icullen navbar
      //const cmsWebappBaseUrl=window['config']['cmsWebappBaseUrl'];
      console.log('api url: ' + apiUrl);
      const isProdEnv = window['config']['production'];

      this.configuration$ = of({
        apiBaseUrl: apiUrl,
        //cmsWebappBaseUrl:cmsWebappBaseUrl,
        production: isProdEnv,
      });
    }
    return this.configuration$;
  }

  public getConfig(): Configuration {
    if (!this.config) {
      this.configuration$.subscribe(config => (this.config = config));
    }
    return this.config;
  }

  public getConfigObservable() {
    return this.configuration$;
  }
}
